import Vue from 'vue'
import Vuex from 'vuex'

import global from '@/global/store'

import auth from '@/modules/auth/store'
import reports from '@/modules/admin/reports/store'
import reportsVideos from '@/modules/admin/reports/store/videos'
import reportsTracks from '@/modules/admin/reports/store/tracks'
import reportsTerritorial from '@/modules/admin/reports/store/territorial'
import reportsChannels from '@/modules/admin/reports/store/channels'
import reportsCategory from '@/modules/admin/reports/store/category'
import reportsVC from '@/modules/admin/reports/store/vidcents'
import user from '@/modules/admin/user/store'
import track from '@/modules/admin/track/store'
import newReleasesTracks from '@/modules/admin/new-releases/store/tracks'
import newReleasesArtists from '@/modules/admin/new-releases/store/artists'
import newReleasesLabels from '@/modules/admin/new-releases/store/labels'
import newReleasesReports from '@/modules/admin/new-releases/store/reports'
import newsletter from '@/modules/admin/newsletter/store'
import reportUser from '@/modules/admin/subscription-catalogues/store/user'
import reportLibraryShare from '@/modules/admin/subscription-catalogues/store/libraryShare'
import trackImport from '@/modules/admin/track-import/store'
import vcLabel from '@/modules/admin/vidcents/store/label'
import vcTrack from '@/modules/admin/vidcents/store/track'
import vcTransactionHistory from '@/modules/admin/vidcents/store/transactionHistory'
import vcPayPal from '@/modules/admin/vidcents/store/paypal'
import bands from '@/modules/admin/vidcents/store/bands'
import vcVideoTracksScanRegular from '@/modules/admin/vidcents/store/videoTracksScanRegular'
import vcVideoTracksScanShorts from '@/modules/admin/vidcents/store/videoTracksScanShorts'
import blogAuthor from '@/modules/admin/cms/store/blogAuthor'
import blog from '@/modules/admin/cms/store/blog'
import contracts from '@/modules/admin/cms/store/contracts'
import testimonial from '@/modules/admin/cms/store/testimonial'
import faq from '@/modules/admin/cms/store/faq'
import challenges from '@/modules/admin/challenges/store/challenges'
import instagram from '@/modules/admin/challenges/store/instagram'
import youtubeShorts from '@/modules/admin/challenges/store/youtubeShorts'
import youtubeRegular from '@/modules/admin/challenges/store/youtubeRegular'

import artistDashboard from '@/modules/artist/dashboard/store/index'
import artistTracks from '@/modules/artist/tracks/store/index'
import artistVideos from '@/modules/artist/videos/store/index'
import artistChannels from '@/modules/artist/channels/store/index'
import artistVidCents from '@/modules/artist/my-vidcents/store/index'
import artistTrackVidCents from '@/modules/artist/my-vidcents/store/track'
import artistMyProfile from '@/modules/artist/my-profile/store/index'

import campaignHighlight from '@/modules/admin/cms/store/campaign-highlight'
import newReleasesCarousel from '@/modules/admin/cms/store/new-releases'
import communityCarousel from '@/modules/admin/cms/store/community'
import opportunityCarousel from '@/modules/admin/cms/store/opportunities'
import affiliate from '@/modules/admin/cms/store/affiliate'
import fileManager from '@/modules/admin/cms/store/fileManager'

import youtubeAssets from '@/modules/admin/cms/store/youtubeAssets'
import youtubeRemovalClaims from '@/modules/admin/cms/store/youtubeRemovalClaims'
import youtubeClaims from '@/modules/admin/cms/store/youtubeClaims'
import youtubeLicensing from '@/modules/admin/cms/store/youtubeLicensing'
import youtubeReports from '@/modules/admin/cms/store/youtubeReports'
import youtubeWhitelist from '@/modules/admin/cms/store/youtubeWhitelist'
import youtubeUsers from '@/modules/admin/cms/store/youtubeUsers'
import youtubeKeywords from '@/modules/admin/cms/store/youtubeKeywords'
import preapproved from '@/modules/admin/cms/store/preapproved'

import labelDashboard from '@/modules/label/dashboard/store/index'
import labelArtist from '@/modules/label/artists/store/index'
import labelVidCents from '@/modules/label/my-vidcents/store/index'
import labelTrackVidCents from '@/modules/label/my-vidcents/store/track'
import labelTracks from '@/modules/label/tracks/store/index'
import labelVideos from '@/modules/label/videos/store/index'
import labelChannels from '@/modules/label/channels/store/index'
import labelMyProfile from '@/modules/label/my-profile/store/index'

import contentHome from '@/modules/content/home/store/index'
import vcVideoTrackScanFreeVideos from '@/modules/admin/vidcents/store/VideoTrackScanFreeVideos'
import artistUsers from '@/modules/admin/user/store/artistUsers'
import labelUsers from '@/modules/admin/user/store/labelUsers'
import creatorUsers from '@/modules/admin/user/store/creatorUsers'
import mcnUsers from '@/modules/admin/user/store/mcnUsers'
import permissionUsers from '@/modules/admin/user/store/permissionUsers'
import adminDashboard from '@/modules/admin/dashboard/store/index'
import brand from "@/modules/admin/brand/store/brand";
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global,
    auth,
    reports,
    reportsVideos,
    reportsTracks,
    reportsTerritorial,
    reportsChannels,
    reportsCategory,
    reportsVC,
    user,
    artistUsers,
    labelUsers,
    creatorUsers,
    mcnUsers,
    permissionUsers,
    track,
    brand,
    newReleasesTracks,
    newReleasesArtists,
    newReleasesLabels,
    newReleasesReports,
    newsletter,
    reportUser,
    reportLibraryShare,
    trackImport,
    vcLabel,
    vcTrack,
    vcTransactionHistory,
    vcPayPal,
    bands,
    vcVideoTracksScanRegular,
    vcVideoTracksScanShorts,
    vcVideoTrackScanFreeVideos,
    blogAuthor,
    blog,
    contracts,
    testimonial,
    faq,
    artistDashboard,
    artistTracks,
    artistVideos,
    artistChannels,
    artistVidCents,
    artistTrackVidCents,
    artistMyProfile,
    campaignHighlight,
    newReleasesCarousel,
    communityCarousel,
    affiliate,
    fileManager,
    labelDashboard,
    labelArtist,
    labelVidCents,
    labelTrackVidCents,
    labelTracks,
    labelVideos,
    labelChannels,
    labelMyProfile,
    contentHome,
    youtubeAssets,
    youtubeRemovalClaims,
    youtubeClaims,
    youtubeLicensing,
    youtubeReports,
    youtubeWhitelist,
    youtubeUsers,
    youtubeKeywords,
    preapproved,
    challenges,
    instagram,
    youtubeShorts,
    youtubeRegular,
    adminDashboard,
    opportunityCarousel
  }
})

export default store
